import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";
import { getMyReferrals } from "@/lib/api/generated/endpoints/auth/auth";
import type { ReferralItem } from "@/lib/api/generated/model";

export type Referral = ReferralItem;

export function referralsInfiniteQueryOptions() {
  return infiniteQueryOptions({
    queryKey: ["referrals"],
    initialPageParam: null as null | string,
    queryFn: async ({ pageParam }) => {
      return await getMyReferrals({ cursor: pageParam ?? undefined });
    },
    placeholderData: keepPreviousData,
    getNextPageParam(page) {
      return page.cursor;
    },
  });
}
